<template>
	<div style="height: 0; width: 0; opacity: 0; display: none;"></div>
</template>

<script>
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, off, set } from "firebase/database";

export default {
	name: 'SimpleNotificationListener',
	props: {
		notificationPath: {
			type: String || Number,
			required: true
		}
	},
	data: () => ({
		app: null,
		database: null,
		notificationsRef: null,
		firebaseConfig: {
			apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
			authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
			databaseURL: process.env.VUE_APP_FIREBASE_RTDB_URL,
			projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
			storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
			messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
			appId: process.env.VUE_APP_FIREBASE_APP_ID
		}
	}),
	mounted() {
		this.init()
	},
	beforeDestroy() {
    this.stopNotificationsRTDBListener()
	},
	methods: {
		init(){
			if (!this.app) {
				this.app = initializeApp(this.firebaseConfig)
				this.database = getDatabase(this.app)
				this.startRTDB()
			}
		},
		startRTDB(){
			if(this.notificationPath){
				this.startNotificationsRTDBListenner()
			}
		},
		startNotificationsRTDBListenner(){
			if(this.notificationsRef){
				this.stopNotificationsRTDBListener()
			}
			if(this.notificationPath){
				this.notificationsRef = ref(this.database, this.notificationPath)
			}
			onValue(this.notificationsRef, this.onNotificationsValue, (error) => console.error('Error RTDB Listener:', error))
		},
		stopNotificationsRTDBListener() {
			if (this.notificationsRef) {
				off(this.notificationsRef)
				this.notificationsRef = null
			}
		},
		onNotificationsValue(snapshot) {
			const data = snapshot.val()
			data && this.$emit('onNotification', data)
			setTimeout(() => {
				set(this.notificationsRef, null)
			}, 200)
		}
	}
}
</script>